document.addEventListener("DOMContentLoaded", function () {
  const faqs = document.querySelectorAll(".faq-item");

  faqs.forEach((faq) => {
    const question = faq.querySelector(".faq-title-wrapper");
    const answer = faq.querySelector(".faq-item-description-wrapper");
    const openIcon = faq.querySelector(".handle-open-item");
    const closeIcon = faq.querySelector(".handle-close-item");

    question.addEventListener("click", function () {
      // Close all other FAQ items
      faqs.forEach((item) => {
        if (item !== faq) {
          item.querySelector(".faq-item-description-wrapper").classList.remove("show");
          item.querySelector(".handle-open-item").classList.remove("hideIcon");
          item.querySelector(".handle-close-item").classList.add("hideIcon");
        }
      });

      // Toggle the current FAQ item
      answer.classList.toggle("show");
      openIcon.classList.toggle("hideIcon");
      closeIcon.classList.toggle("hideIcon");
    });
  });
});
